@if (state?.controls) {
  <zef-form
    [state]="state"
    (submit)="submit.emit()">

    <div class="__header">
      <h2 class="fx:text-center">HTTP Balancer Configuration</h2>
    </div>

    <!-- Connection Handling Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Connection Handling</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Maximum simultaneous connections per worker (Default: {{ defaultValuesMap()['worker_connections'] }})</mat-label>
            <input
              matInput
              type="string"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.worker_connections"
              [placeholder]="!state?.controls.worker_connections.value ? defaultValuesMap()['worker_connections'] || 'Leave empty to use default' : ''" />
            @if (state?.controls.worker_connections.errors?.pattern) {
              <mat-error>Please enter a valid number</mat-error>
            }
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Accept multiple connections at once <strong>(Default: {{ defaultValuesMap()['multi_accept'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.multi_accept">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>How long to keep idle connections open (e.g., 30s, 5m) (Default: {{ defaultValuesMap()['keepalive_timeout'] }})</mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.keepalive_timeout"
              [placeholder]="!state?.controls.keepalive_timeout.value ? defaultValuesMap()['keepalive_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Maximum number of requests per connection <strong>(Default: {{ defaultValuesMap()['keepalive_requests'] }})</strong></mat-label>
            <input
              matInput
              type="string"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.keepalive_requests"
              [placeholder]="!state?.controls.keepalive_requests.value ? defaultValuesMap()['keepalive_requests'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Timeout for reading a response from the proxied server <strong>(Default: {{ defaultValuesMap()['proxy_read_timeout'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_read_timeout"
              [placeholder]="!state?.controls.proxy_read_timeout.value ? defaultValuesMap()['proxy_read_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Timeout for transmitting a request to the proxied server <strong>(Default: {{ defaultValuesMap()['proxy_send_timeout'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_send_timeout"
              [placeholder]="!state?.controls.proxy_send_timeout.value ? defaultValuesMap()['proxy_send_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- Client Request Settings Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Client Request Settings</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Timeout for receiving client request header <strong>(Default: {{ defaultValuesMap()['client_header_timeout'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.client_header_timeout"
              [placeholder]="!state?.controls.client_header_timeout.value ? defaultValuesMap()['client_header_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Timeout for receiving client request body <strong>(Default: {{ defaultValuesMap()['client_body_timeout'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.client_body_timeout"
              [placeholder]="!state?.controls.client_body_timeout.value ? defaultValuesMap()['client_body_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Maximum allowed size of client request body <strong>(Default: {{ defaultValuesMap()['client_max_body_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.client_max_body_size"
              [placeholder]="!state?.controls.client_max_body_size.value ? defaultValuesMap()['client_max_body_size'] || 'Leave empty to use default' : ''" />
            @if (state?.controls.client_max_body_size.errors?.pattern) {
              <mat-error>Please enter a valid size (e.g., 512m, 1G)</mat-error>
            }
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Reset connections that have timed out <strong>(Default: {{ defaultValuesMap()['reset_timedout_connection'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.reset_timedout_connection">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Timeout for transmitting response to client <strong>(Default: {{ defaultValuesMap()['send_timeout'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.send_timeout"
              [placeholder]="!state?.controls.send_timeout.value ? defaultValuesMap()['send_timeout'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- Buffer Settings Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Buffer Settings</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffer for client request header <strong>(Default: {{ defaultValuesMap()['client_header_buffer_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.client_header_buffer_size"
              [placeholder]="!state?.controls.client_header_buffer_size.value ? defaultValuesMap()['client_header_buffer_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Number of buffers for large client headers <strong>(Default: {{ defaultValuesMap()['large_client_header_buffers_number'] }})</strong></mat-label>
            <input
              matInput
              type="string"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.large_client_header_buffers_number"
              [placeholder]="!state?.controls.large_client_header_buffers_number.value ? defaultValuesMap()['large_client_header_buffers_number'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffers for large client headers <strong>(Default: {{ defaultValuesMap()['large_client_header_buffers_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.large_client_header_buffers_size"
              [placeholder]="!state?.controls.large_client_header_buffers_size.value ? defaultValuesMap()['large_client_header_buffers_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffer for client request body <strong>(Default: {{ defaultValuesMap()['client_body_buffer_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.client_body_buffer_size"
              [placeholder]="!state?.controls.client_body_buffer_size.value ? defaultValuesMap()['client_body_buffer_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- Proxy Settings Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Proxy Settings</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Buffer client request body <strong>(Default: {{ defaultValuesMap()['proxy_request_buffering'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.proxy_request_buffering">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Buffer responses from proxied server <strong>(Default: {{ defaultValuesMap()['proxy_buffering'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.proxy_buffering">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffer for first part of response <strong>(Default: {{ defaultValuesMap()['proxy_buffer_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_buffer_size"
              [placeholder]="!state?.controls.proxy_buffer_size.value ? defaultValuesMap()['proxy_buffer_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Number of buffers for proxied server response <strong>(Default: {{ defaultValuesMap()['proxy_buffers_number'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_buffers_number"
              [placeholder]="!state?.controls.proxy_buffers_number.value ? defaultValuesMap()['proxy_buffers_number'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffers for proxied server response <strong>(Default: {{ defaultValuesMap()['proxy_buffers_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_buffers_size"
              [placeholder]="!state?.controls.proxy_buffers_size.value ? defaultValuesMap()['proxy_buffers_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Size of buffers that can be busy sending to client <strong>(Default: {{ defaultValuesMap()['proxy_busy_buffers_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_busy_buffers_size"
              [placeholder]="!state?.controls.proxy_busy_buffers_size.value ? defaultValuesMap()['proxy_busy_buffers_size'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Maximum size of temporary file for buffering <strong>(Default: {{ defaultValuesMap()['proxy_max_temp_file_size'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.proxy_max_temp_file_size"
              [placeholder]="!state?.controls.proxy_max_temp_file_size.value ? defaultValuesMap()['proxy_max_temp_file_size'] || '1024m' : ''" />
            @if (state?.controls.proxy_max_temp_file_size.errors?.pattern) {
              <mat-error>Please enter a valid size (e.g., 512m, 1G)</mat-error>
            }
          </mat-form-field>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- Performance Optimization Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Performance Optimization</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Use sendfile() for file transfers <strong>(Default: {{ defaultValuesMap()['sendfile'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.sendfile">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Enable TCP_NOPUSH socket option <strong>(Default: {{ defaultValuesMap()['tcp_nopush'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.tcp_nopush">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Enable TCP_NODELAY socket option <strong>(Default: {{ defaultValuesMap()['tcp_nodelay'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.tcp_nodelay">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Enable gzip compression <strong>(Default: {{ defaultValuesMap()['gzip'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.gzip">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Rate limit for response transmission (0 = no limit) <strong>(Default: {{ defaultValuesMap()['limit_rate'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.limit_rate"
              [placeholder]="!state?.controls.limit_rate.value ? defaultValuesMap()['limit_rate'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- File Cache Settings Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>File Cache Settings</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Cache open file descriptors <strong>(Default: {{ defaultValuesMap()['open_file_cache'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.open_file_cache">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Maximum number of elements in file cache <strong>(Default: {{ defaultValuesMap()['open_file_cache_max'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.open_file_cache_max"
              [placeholder]="!state?.controls.open_file_cache_max.value ? defaultValuesMap()['open_file_cache_max'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Time after which unused cache elements are removed <strong>(Default: {{ defaultValuesMap()['open_file_cache_inactive'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.open_file_cache_inactive"
              [placeholder]="!state?.controls.open_file_cache_inactive.value ? defaultValuesMap()['open_file_cache_inactive'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Time interval for checking cached elements validity <strong>(Default: {{ defaultValuesMap()['open_file_cache_valid'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.open_file_cache_valid"
              [placeholder]="!state?.controls.open_file_cache_valid.value ? defaultValuesMap()['open_file_cache_valid'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field">
          <mat-form-field color="accent">
            <mat-label>Minimum file uses to remain in cache <strong>(Default: {{ defaultValuesMap()['open_file_cache_min_uses'] }})</strong></mat-label>
            <input
              matInput
              type="text"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.open_file_cache_min_uses"
              [placeholder]="!state?.controls.open_file_cache_min_uses.value ? defaultValuesMap()['open_file_cache_min_uses'] || 'Leave empty to use default' : ''" />
          </mat-form-field>
        </zef-form-field>
      </div>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Cache file lookup errors <strong>(Default: {{ defaultValuesMap()['open_file_cache_errors'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.open_file_cache_errors">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

    </zui-form-section>

    <zui-separator
      spacing="medium"
      orientation="horizontal"
      size="large"
      class="fx:pb-0-75"
    />

    <!-- Security Section -->
    <zui-form-section class="__form-section" separator="none">
      <span *zuiFormSectionTitle>Security</span>

      <div class="fx:grid  fx:grid-cols-1  fx:gap-2">
        <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
          <zef-form-label>Emit nginx version in error messages and headers <strong>(Default: {{ defaultValuesMap()['server_tokens'] }})</strong></zef-form-label>
          <mat-button-toggle-group
            [ngrxEnableFocusTracking]="true"
            [ngrxFormControlState]="state?.controls.server_tokens">
            <mat-button-toggle [value]="true">On</mat-button-toggle>
            <mat-button-toggle [value]="'dflt'">Default</mat-button-toggle>
            <mat-button-toggle [value]="false">Off</mat-button-toggle>
          </mat-button-toggle-group>
        </zef-form-field>
      </div>

    </zui-form-section>

  </zef-form>
}
